export const CONVERSION_TYPE = {
    BASIC: 'BASIC',
    EVENT_BASED: 'EVENT_BASED',
    ENGAGEMENT: 'ENGAGEMENT',
};
